import { computed, defineComponent, watch, ref, onMounted, } from '@vue/composition-api';
import { OFFER_STATUS_COLORS } from '@/constants/offer';
import { genericTableRowSize } from '@/components/Table/__new__/_components/TableCellGeneric';
import TableLoader from '@/views/_components/Table/TableLoader.vue';
import { useUnifiedOfferColumns } from '@/views/Brand/Applications/Offer/_composables/use-unified-offer-columns';
import { GenericAGTable } from '@/components/Table/AGTable/AGTable.vue';
import { getUnifiedOffersList, } from '@/api/v2/requests/unified-offers';
import FloatingTextFilter from '@/components/Table/AGTable/_components/FloatingTextFilter.vue';
import UnifiedOfferStatusCell from '@/views/Brand/Applications/Offer/_components/UnifiedOfferStatusCell/UnifiedOfferStatusCell.vue';
import FloatingSelectFilter from '@/components/Table/AGTable/_components/FloatingSelectFilter.vue';
import { useTableQueryParams } from '@/components/Table/_composables/use-table-query-params';
import { stripEntityPrefix } from '@/util/entity-number';
import TableFooter from '@/views/_components/Table/TableFooter.vue';
export default defineComponent({
    components: {
        TableLoader,
        // eslint-disable-next-line vue/no-unused-components
        FloatingTextFilter,
        // eslint-disable-next-line vue/no-unused-components
        UnifiedOfferStatusCell,
        // eslint-disable-next-line vue/no-unused-components
        FloatingSelectFilter,
        TableFooter,
        AgTable: GenericAGTable(),
    },
    props: {
        selectedPerPage: {
            type: Number,
            default: null,
        },
    },
    setup(props, ctx) {
        const params = ctx.root.$route.params;
        const isLoading = ref(false);
        const rows = ref([]);
        const totalCount = ref(0);
        const brandId = params.id;
        const agTableRef = ref(null);
        const { page, perPage, query: tableQuery, handleFilterChange: handleQueryFilterChange, handleSort, resetSort, } = useTableQueryParams(ctx, {
            defaultPerPage: 25,
            filterParams: {
                internalNumber: 'internalNumber',
                title: 'title',
                status: 'status',
                centralCostName: 'centralCostName',
            },
            filterTransforms: {
                internalNumber: stripEntityPrefix,
            },
            staticParams: {
                brandId,
            },
        });
        watch(() => props.selectedPerPage, (newPerPage) => {
            if (newPerPage && newPerPage !== perPage.value) {
                perPage.value = newPerPage;
                page.value = 1;
            }
        }, { immediate: true });
        const query = computed(() => {
            return { ...tableQuery.value };
        });
        const handleRowClick = (offer) => {
            if (offer.offerType === 'goods') {
                ctx.root.$router.push({
                    name: 'GoodsOfferDetails',
                    params: {
                        id: brandId,
                        goodsOfferId: offer.id,
                    },
                });
            }
            else {
                ctx.root.$router.push({
                    name: 'OfferDetails',
                    params: {
                        id: brandId,
                        offerId: offer.id,
                    },
                });
            }
        };
        const fetchItems = async () => {
            isLoading.value = true;
            try {
                const { nodes, totalCount: nodesCount } = await getUnifiedOffersList(query.value ?? {});
                totalCount.value = nodesCount;
                rows.value = nodes;
            }
            catch (err) {
                console.error('Error fetching unified offers:', err);
                ctx.root.$toast.error(ctx.root.$t(`brand-offers.error-fetching`));
            }
            finally {
                isLoading.value = false;
            }
        };
        const changePage = (newPage) => {
            page.value = newPage;
        };
        const handleFilterChange = (filterModel) => {
            handleQueryFilterChange(filterModel);
        };
        const handleSortChange = (field, sort) => {
            handleSort(field, sort);
        };
        const handleResetSort = () => {
            resetSort();
        };
        onMounted(async () => {
            await fetchItems();
        });
        const { columns } = useUnifiedOfferColumns(ctx);
        watch(query, () => {
            fetchItems();
        }, { deep: true });
        const handlePerPageChange = (newPerPage) => {
            perPage.value = newPerPage;
            page.value = 1;
        };
        return {
            columns,
            tableQuery,
            page,
            perPage,
            totalCount,
            genericTableRowSize,
            OFFER_STATUS_COLORS,
            rows,
            isLoading,
            handleRowClick,
            handleFilterChange,
            handleSortChange,
            handleResetSort,
            changePage,
            agTableRef,
            handlePerPageChange,
        };
    },
});
